module.exports = __webpack_public_path__ + "img/Caret-Right-2.36c536d7.svg";